<div class="content">
    <div class="heading-container">
        <div class="left-section">
            <div class="icon-container" (click)="goBack()">
                <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
            </div>

            <div class="title-container">
                <p class="title font-poppins">{{ action }} Items</p>
                <p class="subtitle">Your {{ action }} request has been created successfully</p>
            </div>
        </div>
    </div>

    <div class="success-title">
        <div class="bg-circle red"></div>

        <div class="content-success">
            <div class="icon">
                <mat-icon [svgIcon]="'tick'"></mat-icon>
            </div>
            <h1 class="title font-poppins">{{ action }} Request Successful 🎉</h1>
            <p class="subtitle">
                Thanks for letting us know! Your {{ action }} has been scheduled and our team will handle it shortly.
            </p>
        </div>
        <div class="bg-circle yellow"></div>
    </div>

    <div class="item-summary">
        <div class="action-title">
            <div class="icon">
                <mat-icon [svgIcon]="'openBox'"></mat-icon>
            </div>
            <h2 class="summary font-poppins">{{ action }} Summary</h2>
        </div>

        <div class="items-detail">
            @for(item of items; let i = $index; track i ){
            <div class="product">
                <img
                    class="product-image"
                    [class]="'product-image-gradient' + ((i % 3) + 1)"
                    [src]="item.product?.images?.imagesUrl?.[0]"
                />
                <div class="product-right-section">
                    <h3 class="product-name font-poppins" appEllipsis="80%">{{ item?.product?.name }}</h3>
                    <p *ngIf="item.product?.modelQuantityJson">
                        {{ item.product?.modelQuantityJson?.totalBlock }} Blocks
                    </p>
                    <h5 class="price font-poppins">
                        ₹
                        {{
                            item.product?.discountedPrice
                                ? (item.product?.discountedPrice | number: "1.0-0")
                                : (item.product?.price | number: "1.0-0")
                        }}
                    </h5>
                </div>
            </div>

            }
        </div>

        @if (action !== 'exchange'){
        <div class="refund-amount">
            <div class="key-section">
                <label>Refund Amount</label>
                <label>Refund Method</label>
                <label>Processing Time</label>
            </div>

            <div class="value-section">
                <h2 class="font-poppins">₹ {{ totalAmount | number: "1.0-0" }}</h2>
                <p>Original Payment</p>
                <p>5-7 Business Days</p>
            </div>
        </div>
        }
    </div>

    <div class="important-tips">
        <div class="head">
            <div class="tips">
                <mat-icon [svgIcon]="'bulb'"></mat-icon>
            </div>
            <h3 class="title font-poppins">Important Tips</h3>
        </div>

        <div class="list">
            <div class="icon">
                <mat-icon [svgIcon]="'tick'"></mat-icon>
            </div>
            <p>
                <span>Pickup Instructions:</span> Our courier will arrive between 2:00 PM - 5:00 PM. Please keep the
                item ready at your doorstep.
            </p>
        </div>
        <div class="list">
            <div class="icon">
                <mat-icon [svgIcon]="'tick'"></mat-icon>
            </div>
            <p>
                <span>Packing Tips:</span> Pack the item securely in its original box. Include all accessories and
                manuals if applicable.
            </p>
        </div>
        <div class="list">
            <div class="icon">
                <mat-icon [svgIcon]="'tick'"></mat-icon>
            </div>
            <p>
                <span> Need Help?</span> Check our
                <a href="https://www.google.com/" target="_blank">Return Policy</a> for detailed guidelines.
            </p>
        </div>
    </div>

    <div class="button">
        <button mat-flat-button class="btn-primary-gradient btn" (click)="goToOrderDetail()">
            <mat-icon [svgIcon]="'location'"></mat-icon>
            Track Return Status
        </button>
        <button mat-flat-button class="btn-secondary-gradient btn" (click)="goToTrack()">
            <mat-icon [svgIcon]="'arrowleft'"></mat-icon>
            Back to Order
        </button>
        <button mat-flat-button class="btn-white continue-shopping btn" (click)="goToHome()">
            <mat-icon [svgIcon]="'cart'"></mat-icon>
            Continue Shopping
        </button>
    </div>
</div>
